import React, { useState, useEffect, Fragment } from "react";
import styled from "styled-components";
import TestingCategorySelect from "../../sample_reception/TestingCategorySelect";

export default function TestingCategory({ value, onChange }) {
  return (
    <Fragment>
      <label>Testing Category</label>
      <TestingCategorySelect value={value} onChange={o => onChange(o.value)} />
    </Fragment>
  );
}
